import styled from 'styled-components';

export const Container = styled.div`
    overflow-y: scroll;
    padding: 50px;
    height: 100%;
    background-color: ${props => props.theme.backgroundColor};
}
`;
